import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { useSelector, useDispatch } from 'react-redux'
// Actions
import { setFilter } from 'src/actions/filters'
// Selectors
import { selectFilter } from 'src/store/selectors/filters'
// Components
import Button from 'src/Components/shared/Button'

const LoadMoreListings = () => {
  const dispatch = useDispatch()
  const filter = useSelector(selectFilter)

  const loadMore = () => {
    dispatch(setFilter({ page: filter.page + 1 }))
  }

  return (
    <Button primary type='submit' onClick={loadMore}>
      <FormattedMessage
        id='HomeSearch.listings.loadMore'
        defaultMessage='Load More'
      />
    </Button>
  )
}

export default LoadMoreListings
